/**
 * Platform detection utility for PWA push notifications
 */
export const getPlatformInfo = () => {
  const { userAgent } = navigator;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isMacOS = /Mac/.test(userAgent);
  const isAndroid = /Android/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  const isApplePlatform = isIOS || (isMacOS && isSafari);

  return {
    isIOS,
    isMacOS,
    isAndroid,
    isSafari,
    isApplePlatform,
    supportsWebPush: !isApplePlatform,
    supportsFCM: 'Notification' in window
    // supportsWebPush:
    //   !isApplePlatform &&
    //   'serviceWorker' in navigator &&
    //   'PushManager' in window,
    // supportsFCM: 'serviceWorker' in navigator && 'Notification' in window
  };
};

/**
 * Get the appropriate platform identifier for push notifications
 */
export const getPushPlatform = () => {
  const platformInfo = getPlatformInfo();

  if (platformInfo.isIOS) return 'ios';
  if (platformInfo.isMacOS && platformInfo.isSafari) return 'macos';
  if (platformInfo.isAndroid) return 'android';
  if (platformInfo.supportsWebPush) return 'webpush';
  return 'web';
};
